import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateGuidance from '@/shared/http/repositories/business/qmaTemplateGuidance'
import { toast, loading } from '@/shared/utils/UIHelper'
// import IconCampoGrande from '../../../../../../../../../static/img/qma/IconCampoGrande.svg'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'
import IconImagem from '../../../../../../../../../static/img/qma/IconImagem.svg'

export default {
  name: 'newHeader',
  props: ['templateid', 'orientacaoId', 'tipoTemplate'],
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      dataQMAOrientacao: [],
      dataFiltroQMAOrientacao: [],
      itensAguardandoEnvio: [],
      buscaItem: '',
      orientacaoid: null,
      templateOrientacaoid: null,
      nivelPrioridade: null,
      Editar: false,
      novoItemDescricao: null,
      novoItemTipo: null,
      semDados: ImageNotFound,
      iconImg: IconImagem,
      cadastros: false,
      addItensLimpaFiltro: false,
      file: null,
      file64: null,
      perguntaId: null,
      nameFile: null
    }
  },

  watch: {
    buscaItem (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaItemlAdd(newvalue)
      } else {
        this.dataFiltroQMAOrientacao = [...this.dataQMAOrientacao]
        if (this.itensAguardandoEnvio.length > 0) {
          this.$nextTick(() => {
            this.restauraclicked(this.itensAguardandoEnvio)
          })
        }
      }
    }
  },
  updated () {
    // Este hook será executado sempre que o DOM for atualizado
    this.$nextTick(() => {
      if (this.itensAguardandoEnvio.length > 0) {
        this.restauraclicked(this.itensAguardandoEnvio) // Chama restauraclicked após atualização do DOM
        if (this.addItensLimpaFiltro === true) {
          this.identificarElementosClicados()
        }
      }
    })
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    focarDescricao () {
      if (this.Editar === false) {
        this.$refs.descricaoTextarea.focus()
      }
    },
    popUptAdd () {
      this.onLoad()
      this.$refs['add-novo-orientacao'].show()
      this.Editar = false
      this.itensAguardandoEnvio = []
      this.nivelPrioridade = null
      this.novoItemDescricao = null
      this.novoItemTipo = null
      this.cadastros = false
      this.nameFile = null
      this.file = null
      this.file64 = null
    },
    popUptEditar (value) {
      this.Editar = true
      this.$refs['add-novo-orientacao'].show()
      this.nivelPrioridade = value.nivel
      this.templateOrientacaoid = value.id
    },
    fecharPopUptAdd () {
      this.$refs['add-novo-orientacao'].hide()
      this.itensAguardandoEnvio = []
      this.novoItemDescricao = null
      this.novoItemTipo = null
      this.cadastros = false
    },
    openFileImg () {
      document.getElementById('impor-Img').click()
    },
    GetValueFile (e) {
      this.nameFile = e.target.files[0].name
      this.file = e.target.files[0]
      this.file64 = e.target.files[0]

      const reader = new FileReader()

      reader.readAsDataURL(this.file64)

      reader.onload = () => {
        this.file64 = reader.result
        console.log(this.file64)
      }
      reader.onerror = (error) => {
        console.error('Erro ao converter o arquivo para Base64 ', error)
      }
    },
    onLoad () {
      loading.push()
      qmaTemplateGuidance.GetItensOrientacao(this.templateid, this.tipoTemplate)
        .then((Response) => {
          loading.pop()
          this.dataQMAOrientacao = Response.data.data
          this.dataFiltroQMAOrientacao = Response.data.data
          this.cadastros = false
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    ItemNovoParaLita () {
      this.cadastros = true
      setTimeout(() => {
      }, 1000)
      // let novoItem = {
      //   id: null,
      //   status: 1,
      //   descricao
      // }
    },
    BuscaItemlAdd (value) {
      this.dataFiltroQMAOrientacao = this.dataQMAOrientacao.filter((Element) => Element.descricao.toUpperCase().indexOf(value.toUpperCase()) > -1)
    },
    AdicionarIten (id) {
      let novoItem = {tipo: id.tipo, descricao: id.descricao, descricaoEdicao: 'AG. ENVIO - NOVO ITEM', edicao: true, templateId: this.templateid, status: 1, id: id.id, colorFonte: 'rgb(0, 55, 137)', colorStatus: 'rgb(212, 238, 253)', check: false, add: true}
      this.itensAguardandoEnvio.push(novoItem)
      this.addItem([id.id])
      // this.Adicionar = !this.Adicionar
      // var div = document.getElementById(id.id)
      // // Verifica se a classe 'clicked' já está presente na div
      // var isClicked = div.classList.contains('clicked')
      // // Se já estiver clicada, remove a classe, caso contrário, adiciona
      // if (isClicked) {
      //   div.classList.remove('clicked')
      //   this.itensAguardandoEnvio = this.itensAguardandoEnvio.filter(item => item.id !== id.id)
      // } else {
      //   div.classList.add('clicked')
      // }
    },
    restauraclicked (Lista) {
      for (let j = 0; j < Lista.length; j++) {
        var div = document.getElementById(Lista[j].id)
        if (div != null) {
          div.classList.add('clicked')
        }
      }
    },
    identificarElementosClicados () {
      if (this.buscaItem === '') {
        var elementosClicados = []
        this.dataQMAOrientacao.forEach(function (elemento) {
          var elementoHTML = document.getElementById(elemento.id)
          if (elementoHTML && elementoHTML.classList.contains('clicked')) {
            elementosClicados.push(elementoHTML.id)
          }
        })
        if (elementosClicados.length > 0) {
          this.addItem(elementosClicados)
        } else {
          toast.warning('Adicione pelo menos um item')
        }
      } else {
        this.addItensLimpaFiltro = true
        this.buscaItem = ''
      }
    },
    editarOrientacao () {
      this.dataEditarOrientacao = {templateOrientacaoId: this.templateOrientacaoid, nivelPrioridade: this.nivelPrioridade}
      this.$emit('EditaOrientacao', this.dataEditarOrientacao)
      this.$emit('AlteracaoOrientacao', this.dataEditarOrientacao)
      this.fecharPopUptAdd()
    },
    addItem (ids) {
      console.log(ids)
      this.datanewItens = {OrientacaoId: ids[0], nivelPrioridade: this.nivelPrioridade}
      this.$emit('salvarNovosItensOrientacao', this.datanewItens)
      this.$emit('AdicionarTableOrientacao', this.itensAguardandoEnvio)
      this.fecharPopUptAdd()
    },
    validaCampos () {
      this.novoItemDescricao = this.novoItemDescricao !== null && this.novoItemDescricao !== undefined ? this.novoItemDescricao.trim() : this.novoItemDescricao
      if (this.novoItemDescricao == null || this.novoItemDescricao === '') {
        return toast.warning('Informe a descrição do item')
      }
      this.salvarNovoItem()
    },
    salvarNovoItem () {
      loading.push()
      const formData = new FormData()
      formData.append('file', this.file)

      qmaTemplateGuidance.PostNovoItemOrientacao(this.novoItemDescricao, this.tipoTemplate, this.CompanySelected, formData)
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.novoItemTipo = null
          this.file64 = null
          this.AdicionarIten(Response.data.result)
          toast.success('Sucesso na criação')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    removerOpcoesImagem () {
      this.nameFile = null
      this.file = null
      this.file64 = null
    },
    downloadOrientacaoImagem (url, id) {
      loading.push()

      qmaTemplateGuidance.DownloadOrientacaoTemplate({url: url})
        .then((Response) => {
          loading.pop()
          this.file64 = Response.data
          this.perguntaId = id
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('Download não concluído')
        })
    },
    fechaImg () {
      this.file64 = null
      this.perguntaId = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/newGuidance/newGuidance.js